import { render, staticRenderFns } from "./ModalAddClienteDkpToken.vue?vue&type=template&id=a6937822&scoped=true&"
import script from "./ModalAddClienteDkpToken.vue?vue&type=script&lang=js&"
export * from "./ModalAddClienteDkpToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6937822",
  null
  
)

export default component.exports